import React from 'react';
import {SectionDetail, Button, RaymanUser, TabPanel} from 'components/core';
import {Grid} from '@material-ui/core';
import {UsersCtx} from 'components/dataProviders/users';
import {Edit, Archive, Unarchive} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import UserDialog from './dialog';
import UserInfo from 'components/users/UserInfo';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 25
  },
  infoPair: {
    marginTop: 25
  },
  infoTitle: {
    fontSize: '18px',
    FontWeight: 800,
    color: theme.palette.text.secondary
  },
  infoField: {
    fontSize: '15px',
    FontWeight: 600,
    color: theme.palette.text.secondary,
    whiteSpace: "pre-line"
  },
}), {name: "UserPanel"});


export default function UserPanel({userID, onClose = () => {}})
{
    const [editDialogOpen, setEditDialogOpen] = React.useState(false);
    const usersCtx = React.useContext(UsersCtx);
    const classes = useStyles();
    const user = usersCtx.data.indexed[userID];

    const handleClose = () => {
        onClose();
    }

    function disable()
    {
      usersCtx.funcs.disable(userID);
    }

    function enable()
    {
      usersCtx.funcs.enable(userID);
    }

    if(!userID) return null;

    const header = <Grid container direction="row" spacing={2} justify="space-between">
      <Grid item><Grid container direction="row" spacing={1}>
        <Grid item><Button color="secondary" fullWidth={false} onClick={()=>setEditDialogOpen(true)}><Edit /> Editar</Button></Grid>
        {!user.disabled && <Grid item><Button color="error" fullWidth={false} onClick={disable}><Archive /> Desactivar</Button></Grid> }
        {user.disabled && <Grid item><Button color="secondary" fullWidth={false} onClick={enable}><Unarchive /> Activar</Button></Grid> }
      </Grid></Grid>
    </Grid>

    return <SectionDetail onCloseClick={() => handleClose()} header={header}>
      <UserDialog userID={userID} open={editDialogOpen} onClose={()=>setEditDialogOpen(false)} />
      <UserInfo user={user} />
  </SectionDetail>
}